import { getRoutes } from '@ui-framework/index';
import AuthorizationWrapper, {
  authFnForMaintenancePages,
  authFnForMaintenanceCreatePages,
} from '@product-framework/components/AuthorizationWrapper';
import ServiceSiteEdit from './pages/edit/index';
import ServiceSiteCreate from './pages/create/index';
import ServiceSiteList from './pages/list/index';
import schema from './schemas/routes.json';
import ErrorPage, { ERROR_PAGE_TYPE } from '../ErrorPage';

import ServiceSiteFormStore from './store/index';

const Pages = ProtectedRoute => ({
  ServiceSiteEdit: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ServiceSiteEdit}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnForMaintenancePages],
      }}
    />
  ),
  ServiceSiteCreate: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ServiceSiteCreate}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnForMaintenanceCreatePages],
      }}
    />
  ),
  ServiceSiteList: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ServiceSiteList}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnForMaintenancePages],
      }}
    />
  ),
});

const routes = ({ ProtectedRoute, BubbleRouteError }) =>
  getRoutes({
    schema,
    ProtectedRoute,
    BubbleRouteError,
    Pages: Pages(ProtectedRoute),
  });

const stores = rootStore => [
  { servicesiteFormStore: new ServiceSiteFormStore(rootStore) },
];

export { ServiceSiteEdit, ServiceSiteCreate, ServiceSiteList, routes, stores };
